import { initSearch } from "lib/algolia";

export async function fetchViatorActivitiesByDestination({
  destinationSlug,
  fallback = false,
  hitsPerPage = 30,
  ids = [],
}) {
  const client = initSearch();

  // const index = client.initIndex("viator_products");

  const idsFacetFilter = ids.map(
    (id) => `wherenext_destination_activity_id:${id}`
  );

  const searchResults = await client.search({
    requests: [
      {
        indexName: "viator_products",
        query: destinationSlug,
        hitsPerPage,
        facetFilters: [
          `wherenext_destination_slug:${destinationSlug}`,
          `fallback:${fallback}`,
          idsFacetFilter,
        ],
      },
    ],
  });

  return searchResults?.results[0];
}
export async function fetchViatorActivitiesById({
  ids = [],
  source = "viator",
}) {
  if (source === "algolia") {
    return await fetchViatorActivitiesAlgolia({ ids });
  } else if (source === "viator") {
    return await fetchViatorActivitiesViator({ ids });
  }
}

export async function fetchViatorActivitiesAlgolia({ ids }) {
  try {
    const client = initSearch();

    const index = client.initIndex("viator_products");

    const idsFacetFilter = ids.map((id) => `productCode:${id}`);

    const searchResults = await index.search("", {
      hitsPerPage: 50,
      facetFilters: [idsFacetFilter],
    });

    const filteredResults = searchResults.hits.filter((hit) =>
      ids.includes(hit.productCode)
    );

    return filteredResults;
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function fetchViatorActivitiesViator({ ids }) {
  try {
    const response = await fetch(
      `/api/external/viator/products/bulk?productCodes=${ids}`
    );

    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
}
